import React from "react";
import {ReactComponent as AuthLogoIcon} from "../../icons/auth-logo.svg";
import PrimaryButton from "../ui/buttons/PrimaryButton";
import TextButton from "../ui/buttons/TextButton";
import AuthOverlay from "./AuthOverlay";

export default function Register({onClose, onSwitch}) {
  // DEV
  const dev = true;
  const antdInputClass =
    "";

  return (
    <AuthOverlay onClose={onClose}>
      <div
        className="relative w-[868px] bg-white rounded-[20px] flex flex-col items-center pt-10 pb-5"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Logo block */}
        <div
          className="w-16 h-16 absolute -top-[5%] rounded-[16px] flex items-center justify-center overflow-hidden"
          aria-hidden="true"
        >
          <AuthLogoIcon/>
        </div>
        {/* Dev notice */}
        <div className="mt-6 w-[358px]">
          <div className="w-full rounded-[12px] border border-[#FFE2B3] bg-[#FFF7E6] px-4 py-3">
            <div className="text-[12px] font-bold uppercase tracking-[0.08em] text-[#9A5B00]">
              В разработке
            </div>
            <div className="mt-1 text-[13px] leading-[18px] text-[#5C607C]">
              Самостоятельная регистрация временно недоступна. Регистрация выполняется через администрацию.
            </div>
          </div>
        </div>
        {/* Dev notice */}
        {/* Header */}
        <div className="mt-6 flex flex-col gap-3 items-stretch w-[358px]">
          <h1
            className="m-0 w-full h-[38px] font-bold text-[28px] leading-[38px] text-center tracking-[-0.02em] text-[#01051F]">
            Регистрация
          </h1>
          <p className="m-0 w-full h-[28px] font-normal text-[16px] leading-[28px] text-center text-[#5C607C]">
            Ваш старт с нашим продуктом
          </p>
        </div>

        {/* Form */}
        <form
          className="mt-10 w-[756px] grid grid-cols-2 gap-x-10 gap-y-4"
          onSubmit={(e) => e.preventDefault()}
        >
          {/* Логин */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Логин
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                className={antdInputClass}
                bordered={false}
                disabled={dev}
                placeholder="Укажите логин"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Имя */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Имя
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="text"
                placeholder="Укажите имя"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Почта */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Почта
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="email"
                placeholder="Укажите почту"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Фамилия */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Фамилия
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="text"
                placeholder="Укажите фамилию"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Пароль */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Пароль
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="password"
                placeholder="Введите пароль"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Телефон */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Телефон
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="tel"
                placeholder="Укажите телефон"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Еще раз (подтверждение пароля) */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Еще раз
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="password"
                placeholder="Подтвердите пароль"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>

          {/* Телеграм */}
          <div className="flex flex-col gap-1 h-[102px]">
            <label className="inline-block h-6 font-medium text-[16px] leading-6 text-[#040E44]">
              Телеграм
            </label>
            <div
              className="box-border flex items-center py-[10px] px-[14px] gap-2 w-full h-[46px] bg-white border border-[#C4CBF5] shadow-[0_1px_10px_rgba(4,14,68,0.12)] rounded-[10px]">
              <input
                disabled={dev}
                className="w-full h-6 border-0 outline-none bg-transparent text-[16px] leading-6 text-[#5C607C] placeholder:text-[#5C607C]"
                type="text"
                placeholder="Укажите телеграм"
              />
            </div>
            <p className="text-[12px] leading-[22px] text-[#D30B0B]">Ошибка</p>
          </div>
        </form>

        {/* Button */}
        <div className="mt-10 w-[358px] flex flex-col items-center">
          <PrimaryButton disabled={dev} children={"Зарегистрироваться"} type="submit"></PrimaryButton>
          <p className="w-[358px] h-[18px] mt-6 text-center font-medium text-[12px] leading-[18px] text-[#333F51]">
            Уже есть учетная запись?{" "}
            <TextButton onClick={onSwitch}>
              Войти
            </TextButton>
          </p>
        </div>
      </div>
    </AuthOverlay>
  );
}